import { render, staticRenderFns } from "./HistorySlider.vue?vue&type=template&id=5faf9007&"
import script from "./HistorySlider.vue?vue&type=script&lang=ts&"
export * from "./HistorySlider.vue?vue&type=script&lang=ts&"
import style0 from "./HistorySlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports